import { render, staticRenderFns } from "./programIB.vue?vue&type=template&id=436b2c5d"
import script from "./programIB.vue?vue&type=script&lang=js"
export * from "./programIB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports